<div *transloco="let t">
	<div cdkOverlayOrigin #trigger="cdkOverlayOrigin">
		<mat-form-field [ngClass]="'w-full'" appearance="fill">
			<mat-label>{{ t('userProfile.newPassword') }}</mat-label>
			<input
				[formControl]="passwordFC"
				matInput
				[type]="showNewPassword() ? 'text' : 'password'"
				(keyup)="getPasswordStrength()"
				(focus)="emitFocusEvent(true)"
				(focusout)="emitFocusEvent(false)" />
			<button
				mat-icon-button
				matSuffix
				(click)="showNewPassword.set(!showNewPassword())"
				[attr.aria-label]="'Hide password'"
				[attr.aria-pressed]="!showNewPassword()">
				<mat-icon [svgIcon]="icons.get(!showNewPassword() ? 'visibility' : 'visibility_off')"></mat-icon>
			</button>
			@if (showPasswordStrengthMeter() && placePasswordStrengthMeterInInput()) {
				<div *ngTemplateOutlet="strengthMeter"></div>
			}
		</mat-form-field>
		@if (showPasswordStrengthMeter() && !placePasswordStrengthMeterInInput()) {
			<div *ngTemplateOutlet="strengthMeter"></div>
		}
	</div>

	<ng-template #strengthMeter>
		<div
			class="passwordStrengthMeter flex flex-row"
			[style]="!placePasswordStrengthMeterInInput() ? 'transform: translateY(-15px);' : ''"
			(mouseover)="isOpen.set(true)"
			(mouseout)="isOpen.set(false)">
			@switch (score()) {
				@case (1) {
					<div [ngClass]="'weakest  w-1/5'">
						<div [ngClass]="'strength-meter'"></div>
					</div>
				}
				@case (2) {
					<div [ngClass]="'weak w-2/5'">
						<div [ngClass]="'strength-meter'"></div>
					</div>
				}
				@case (3) {
					<div [ngClass]="'mediocre w-3/5'">
						<div [ngClass]="'strength-meter'"></div>
					</div>
				}
				@case (4) {
					<div [ngClass]="'strong w-4/5'">
						<div [ngClass]="'strength-meter'"></div>
					</div>
				}
				@case (5) {
					<div [ngClass]="'excellent w-full'">
						<div [ngClass]="'strength-meter'"></div>
					</div>
				}
				@default {
					<div [ngClass]="'empty w-full'">
						<div [ngClass]="'strength-meter'"></div>
					</div>
				}
			}
		</div>
	</ng-template>

	<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isOpen()">
		<div class="passwordStrength p-3">
			<u>
				<b>{{ t('userProfile.passwordTooltip') }}</b>
			</u>
			<ul>
				<li [ngClass]="minLengthValid() ? 'valid' : 'invalid'">
					<div class="pw-hint">
						<mat-icon [svgIcon]="minLengthValid() ? icons.get('checkCircle') : icons.get('cancelCircle')" class="mr-1"></mat-icon>
						<span class="text">
							{{ t('userProfile.minLength').replace('%', minLength()) }}
							{{ passwordFC.value.length < minLength() ? ' ' + passwordFC.value.length + '/' + minLength() : '' }}
						</span>
					</div>
				</li>
				<li [ngClass]="amtLowerCaseValid() ? 'valid' : 'invalid'">
					<div class="pw-hint">
						<mat-icon [svgIcon]="amtLowerCaseValid() ? icons.get('checkCircle') : icons.get('cancelCircle')" class="mr-1"></mat-icon>
						<span class="text">{{ t('userProfile.amtLowerCase').replace('%', lowerCaseAmt()) }}</span>
					</div>
				</li>
				<li [ngClass]="amtUpperCaseValid() ? 'valid' : 'invalid'">
					<div class="pw-hint">
						<mat-icon [svgIcon]="amtUpperCaseValid() ? icons.get('checkCircle') : icons.get('cancelCircle')" class="mr-1"></mat-icon>
						<span class="text">{{ t('userProfile.amtUpperCase').replace('%', upperCaseAmt()) }}</span>
					</div>
				</li>
				<li [ngClass]="amtDigitValid() ? 'valid' : 'invalid'">
					<div class="pw-hint">
						<mat-icon [svgIcon]="amtDigitValid() ? icons.get('checkCircle') : icons.get('cancelCircle')" class="mr-1"></mat-icon>
						<span class="text">{{ t('userProfile.amtDigits').replace('%', digitAmt()) }}</span>
					</div>
				</li>
				<li [ngClass]="amtSpecialCharValid() ? 'valid' : 'invalid'">
					<div class="pw-hint">
						<mat-icon [svgIcon]="amtSpecialCharValid() ? icons.get('checkCircle') : icons.get('cancelCircle')" class="mr-1"></mat-icon>
						<span class="text">
							{{ t('userProfile.amtSpecialChars').replace('%', specialCharAmt()) }}
							<br />
							{{ t('userProfile.specialCharDescription') }}
						</span>
					</div>
				</li>
			</ul>
		</div>
	</ng-template>
</div>
